import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { deletePanel, PanelWithDetails } from '../../../../api/panels';
import { toast } from 'react-toastify';
import './PanelModal.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  panelToDelete: PanelWithDetails | null;
  onPanelDeleted: () => Promise<void>;
};

const DeletePanelModal: React.FC<Props> = ({ 
  isOpen, 
  onClose, 
  panelToDelete, 
  onPanelDeleted 
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onDeleteClick = async () => {
    if (!panelToDelete) return;
    
    setLoading(true);
    try {
      await deletePanel(panelToDelete.id);
      toast.success('Panel deleted successfully');
      onPanelDeleted();
    } catch (error) {
      console.log('error :>> ', error);
      toast.error('Failed to delete panel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      width="420px"
    >
      <div className="delete-block-container">
        <div className="modal-header">
          <div className="title">Are you sure you want to delete this panel?</div>
        </div>

        <div className="submit-btn-wrapper">
          <Button
            text="No"
            onClick={onClose}
          />
          <Button 
            text="Yes" 
            onClick={onDeleteClick} 
            isLoading={loading} 
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeletePanelModal;

